export default {
  logisticProviderLogo(state) {
    return `${process.env.S3_ASSETS_URL}images/logistic_provider/${state.invoice.logistic_provider.id}.png`;
  },
  deliveryMethods(state) {
    return state.invoice.logistic_provider.delivery_methods;
  },
  deliveryMethodsNames(state, getters) {
    return getters.deliveryMethods
      .map(dm => dm.name)
      .join(', ');
  },
  tabResume(state) {
    const formatValues = (value) => {
      if (!value) return [];

      const { lines } = value;

      return [
        value,
        ...lines.map(line => Object.assign(line, { isChild: true })),
      ];
    };

    const {
      divergence_values,
      success_values,
      error_values,
    } = state.invoice;

    return [
      ...formatValues(divergence_values),
      ...formatValues(success_values),
      ...formatValues(error_values),
    ];
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/store/getters.js